import { Heart } from "lucide-react";
import { useServerFn } from "@tanstack/react-start";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getMyWishlistIds, toggleWishlist } from "@/lib/wishlist.functions";
import { useAuth } from "@/lib/auth";
import { useNavigate } from "@tanstack/react-router";

export function WishlistButton({ productId, className = "" }: { productId: string; className?: string }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const qc = useQueryClient();
  const fetchIds = useServerFn(getMyWishlistIds);
  const toggle = useServerFn(toggleWishlist);

  const { data } = useQuery({
    queryKey: ["wishlist-ids"],
    queryFn: () => fetchIds(),
    enabled: !!user,
  });
  const isIn = !!data?.ids.includes(productId);

  const m = useMutation({
    mutationFn: () => toggle({ data: { product_id: productId } }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["wishlist-ids"] });
      qc.invalidateQueries({ queryKey: ["my-wishlist"] });
    },
  });

  const onClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) { navigate({ to: "/prijava" }); return; }
    m.mutate();
  };

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={isIn ? "Odstrani iz seznama želja" : "Dodaj na seznam želja"}
      title={isIn ? "Odstrani iz seznama želja" : "Dodaj na seznam želja"}
      aria-pressed={isIn}
      className={`grid h-10 w-10 place-items-center rounded-full bg-background/90 backdrop-blur border border-border hover:border-accent transition-colors ${className}`}
    >
      <Heart className={`h-4 w-4 ${isIn ? "fill-accent text-accent" : "text-foreground"}`} />
    </button>
  );
}
